import { detectLogLevel, LOG_LEVELS, LogLevel } from './logLevels.ts';

export const filterLogsByLevel = (logs: string, enabledLevels: LogLevel[]): string => {
  if (!logs || enabledLevels.length === LOG_LEVELS.length) return logs;

  const enabled = new Set(enabledLevels);
  const keptLines: string[] = [];
  let currentLevel: LogLevel | null = null;

  for (const line of logs.split('\n')) {
    currentLevel = detectLogLevel(line) ?? currentLevel;

    if (currentLevel === null || enabled.has(currentLevel)) {
      keptLines.push(line);
    }
  }

  return keptLines.join('\n');
};
